import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar, MobileSidebar } from './Sidebar'
import { TopNav } from './TopNav'

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false)
  return (
    <div className="min-h-screen app-canvas">
      <div className="flex">
        <Sidebar />
        <MobileSidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
        <div className="flex-1 min-w-0">
          <TopNav onMobileMenuClick={() => setMobileOpen(true)} />
          <main className="px-3 py-4 sm:px-6 sm:py-6 lg:px-8 max-w-screen-2xl mx-auto animate-fade-in-up">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}
